import React, { useEffect } from 'react';
import { axiosInstance } from '~/api/config/axios.config';
import { isArray } from 'class-validator';
import Typography from '@material-ui/core/Typography';
import { CustomSelectChip } from '~/features/dashboard/components/song-details/coponents/SynchTab';

interface SynchTag {
    customField: number;
    id: number;
    listingArea: string;
    listingCode: string;
    listingKey: string;
    listingText: string;
    totalRows: number;
}

export const FilterSynch: React.FC<{ title: string; setFilter: (event: any) => void }> = ({ title, setFilter }) => {
    const [tagName, setTagName] = React.useState<string[]>([]);
    const [tags, setTags] = React.useState<SynchTag[]>([]);

    useEffect(() => {
        axiosInstance.get(`/catalogue/projectCreator/userlisting/list?listingkey=SONG${title}&listingarea=PUBLISHING`).then(resp => {
            setTags(resp.data);
        });
        // eslint-disable-next-line
    }, [title]);

    const handleChange = (event: any) => {
        isArray(event.target.value) ? setTagName(event.target.value as string[]) : setTagName([event.target.value]);
        !isArray(event.target.value) && setFilter([event.target.value]);
        if (isArray(event.target.value)) {
            setFilter(
                event.target.value.map((item: any) => {
                    return item;
                })
            );
        }
    };

    const handleDelete = (chipToDelete: any) => {
        setTagName(chips => chips.filter(chip => chip !== chipToDelete));
        setFilter(tagName.filter(chip => chip !== chipToDelete));
    };

    return (
        <>
            <Typography variant={'subtitle1'}>{title}</Typography>
            <CustomSelectChip multiselect handleChange={handleChange} tagName={tagName} tags={tags} handleDelete={handleDelete} />
        </>
    );
};
